// PATH: src/components/editor/WISIWYG.tsx
import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';

import grapesjsBlocksBasic from 'grapesjs-blocks-basic';
import grapesjsPresetWebpage from 'grapesjs-preset-webpage';

import { Editor } from 'grapesjs'; // ← type import

interface WYSIWYGProps {
    setGetContent: React.Dispatch<React.SetStateAction<() => { html: string; css: string }>>;
    initialContent?: { html?: string; css?: string };
}

const WYSIWYG: React.FC<WYSIWYGProps> = ({ setGetContent, initialContent }) => {
    const editorRef = useRef<Editor | null>(null);
    const editorContainerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!editorContainerRef.current) return;

        const editor = grapesjs.init({
            container: editorContainerRef.current,
            height: '800px',
            width: '100%',
            fromElement: false,
            storageManager: { type: 'none' },
            plugins: [grapesjsBlocksBasic, grapesjsPresetWebpage],
        });

        // ✅ on tape 'ed' en Editor pour éviter l'implicit any
        editor.Commands.add('open-code', {
            run(ed: Editor) {
                const html = ed.getHtml();
                const css = ed.getCss() ?? '';

                const container = document.createElement('div');
                container.style.width = '100%';
                container.style.height = '70vh';
                container.style.display = 'flex';
                container.style.flexDirection = 'column';

                // ——— Ici, mets ton éditeur (CodeMirror v6) si besoin ———
                const pre = document.createElement('textarea');
                pre.style.flex = '1';
                pre.value = `<!-- HTML -->\n${html}\n\n<style>\n${css}\n</style>`;
                container.appendChild(pre);

                const modal = ed.Modal;
                modal.open({ title: 'Éditer le code', content: container });
                const mdl = modal.getModel();

                const onClose = () => {
                    if (mdl.get('open')) return;
                    const content = pre.value;
                    const cssMatch = content.match(/<style>([\s\S]*?)<\/style>/i);
                    const newCss = cssMatch ? cssMatch[1] : '';
                    const newHtml = content.replace(/<style>[\s\S]*?<\/style>/i, '').trim();

                    ed.setComponents(newHtml || '');
                    ed.setStyle(newCss || '');
                    mdl.off('change:open', onClose);
                };

                mdl.on('change:open', onClose);
            },
        });

        editor.Panels.addButton('options', {
            id: 'open-code',
            label: '</>',
            command: 'open-code',
            attributes: { title: 'Éditer le code HTML/CSS' },
        });

        const getContent = () => ({
            html: editor.getHtml(),
            css: editor.getCss() ?? '',
        });
        setGetContent(() => getContent);

        editorRef.current = editor;

        return () => {
            editorRef.current?.destroy();
            editorRef.current = null;
        };
    }, [setGetContent]);

    useEffect(() => {
        if (!editorRef.current) return;

        editorRef.current.setComponents(initialContent?.html || '');
        editorRef.current.setStyle(initialContent?.css || '');
    }, [initialContent]);

    return (
        <div style={{ padding: '20px' }}>
            <div ref={editorContainerRef} style={{ border: '1px solid #ddd', minHeight: '600px' }} />
        </div>
    );
};

export default WYSIWYG;
